<template>
  <div class="consu-container">
    <p class="top"> <span :class="headClass" style="position: absolute; left: 0; top: 0;"><Icon type="md-menu" size="24"/>{{companyName}}</span> 自选 <span class="edit" @click="editFun" v-show="data.length !== 0"> {{ editLabel }} </span></p>
    <Row class="market">
      <span>交易所</span>
      <span>代码</span>
      <span>进场价</span>
      <span>执行价</span>
    </Row>
    <p class="no-info" v-if="data.length === 0">暂无自选信息</p>
    <Row class="claecla" v-else>
      <Row class="code" v-for="(item, index) in data" :key="index">
        <span @click="goTpage(item.market, item.code, item.expiring_date, item)"> <Icon type="ios-close-circle" class="close" v-show="delShow" @click.stop="delOpFun(item)"/> {{ item.market }} </span>
        <span @click="goTpage(item.market, item.code, item.expiring_date, item)"> {{ item.code }} </span>
        <span @click="goTpage(item.market, item.code, item.expiring_date, item)"> {{ item.newPrice }}</span>
        <span @click="goTpage(item.market, item.code, item.expiring_date, item)"> {{ item.strikePrice }}</span>
      </Row>
    </Row>
    <BottonTab></BottonTab>
  </div>
</template>

<script>
import BottonTab from '@/components/BottonTab'
import axios from '@/axios'
import global_ from '@/components/Global.vue'
export default {
  name: 'optionalHome',
  components: {BottonTab},
  data () {
    return {
      switchValue: true,
      Loop: 0,
      editLabel: '编辑',
      delShow: false,
      nowDate: '',
      data: [],
    }
  },
  created() {
    // this.nowDate = window.sessionStorage.getItem('nowDate')
    // this.start()
  },
  methods: {
    // testVues: function () {
    //   this.optionalCode = this.$store.state.optionalCode
    // },
    start() {
      let login = window.sessionStorage.getItem('login')
      if(login) {
        this.getServerOptional()
      } else {
        this.getLocalOptional()
      }
    },
    getServerOptional() {   //登录的情况下获取服务器自选信息
      axios.post('client/querySelfSelectionList.do').then(result => {
        if(result.data.success) {
          let data = result.data.listSelfSelectionModel ? result.data.listSelfSelectionModel : []
          this.data = data
        }
      })
    },
    getLocalOptional() {    //没登录的情况下获取本地自选信息
      let data = window.localStorage.getItem('optionalCode')
      this.data = JSON.parse(data)
    },
    editFun: function () {
      if (this.editLabel === '编辑') {
        this.delShow = true
        this.editLabel = '完成'
      } else {
        this.delShow = false
        this.editLabel = '编辑'
      }
    },
    // 本地删除自选
    delOpFun: function (row) {
      let that = this
      that.$Modal.confirm({
        title: '是否删除' + row.detailsCode,
        onOk: () => {
          let login = window.sessionStorage.getItem("login")
          if(login) {
            this.delStart(row)
          } else {
            let ind = that.$store.state.optionalCode.indexOf(row)
            that.$store.state.optionalCode.splice(ind, 1)
            localStorage.setItem('optionalCode', JSON.stringify(that.$store.state.optionalCode))
            that.$store.dispatch('changeOptional', that.$store.state.optionalCode)
            that.$Message.success('删除成功')
            this.start()
          }
        },
        onCancel: () => {
          that.$Message.info('已取消删除')
        }
      })
    },
    // 后端删除自选
    delStart(item){
      axios.post('client/deleteSelfSelection.do',this.qs.stringify({
        detailsCode: item.detailsCode,
      })).then(res => {
        if(res.data.success) {
          this.$Message.success('删除成功')
          this.getServerOptional()
        }
      })
    },
    goTpage: function (m, c, e, item) {
      this.$router.push({
        path: '/TPage',
        name: 'TPageHome',
        params: {
          market: m,
          code: c,
          expiryDate: e,
          nowDate: this.nowDate,
          buyCpsDays: item.ask_deduction,
          sellCpsDays: item.bid_deduction,  
          subAccountNo: item.subAccountNo,
          yearSession: item.yearTradeDays,
        }
      })
    }
    // showDeleteButton (e) {
    //   let that = this
    //   clearTimeout(that.Loop)
    //   that.Loop = setTimeout(function () {
    //     that.$Modal.confirm({
    //       title: '是否删除' + e.opInfo,
    //       onOk: () => {
    //         let ind = that.$store.state.optionalCode.indexOf(e)
    //         that.$store.state.optionalCode.splice(ind, 1)
    //         localStorage.setItem('optionalCode', JSON.stringify(that.$store.state.optionalCode))
    //         that.$store.dispatch('changeOptional', that.$store.state.optionalCode)
    //         that.$Message.info('删除成功')
    //       },
    //       onCancel: () => {
    //         //  that.$Message.info('已取消删除')
    //       }
    //     })
    //   }, 1000)
    // },
    // clearLoop (e) {
    //   clearTimeout(this.Loop)
    // }
  },
  watch: {
    $route: {
      handler(to, from){
        if(to.name == "optionalHome") {
          this.nowDate = window.sessionStorage.getItem('nowDate')
          this.start()
        }
      },
      immediate: true
    }
  },
  computed: {
    companyName() {
      return global_.companyName
    },
    headClass() {
      let sys = global_.system
      if(sys == '') {
        return 'production-color'
      } else if(sys == '仿真环境') {
        return 'emulator-color'
      } else {
        return 'other-color'
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.consu-container{
  position: relative;
  width: 100%;
  max-width: 750px;
  min-width: 320px;
  margin: 0 auto;
}
.top{
  position: relative;
  z-index: 2;
  height: 2rem;
  width: 100%;
  max-width: 750px;
  line-height: 2rem;
  text-align: center;
  border-bottom: 1px solid #ccc;
  box-shadow:1px 1px 1px #ddd;
}
.top .edit{
  position: absolute;
  right: 15px;
}
.market{
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  height: 2.25rem;
  line-height: 2.25rem;
  background-color: white;
  width: 100%;
  max-width: 750px;
}
.market span{
  display: block;
  float: left;
  width: 25%;
  text-align: center;
  border-bottom: 1px solid #ccc;
}
.no-info{
  height: 2rem;
  width: 100%;
  max-width: 750px;
  line-height: 2rem;
  text-align: center;
}
.claecla{
 height: 100%
}
.code{
  height: 2rem;
  max-height: 2rem;
  overflow: hidden;
  line-height: 2rem;
  width: 100%;
  border-bottom: 1px solid #eee;
}
.code span{
  position: relative;
  color: #515a6e;
  display: block;
  float: left;
  width: 25%;
  text-align: center;
  border-bottom: 1px solid #eee;
}
.code .close{
  position: absolute;
  left: 8px;
  top: 10px;
  font-size: 18px;
}
</style>
